import qrCode from './qrCode.vue'
export default qrCode